import { combineReducers } from 'redux'

import * as actionsTypes from './AudioPlayer/actionsNames'

const queue = (state = [], action) => {
	switch (action.type) {
		case actionsTypes.SET_FROM_STORAGE:
			return action.storage && action.storage.playQueue && action.storage.playQueue.queue || []
		case actionsTypes.SET_PLAYQUEUE:
			return action.playqueue
		case actionsTypes.SET_PLAYQUEUE_NEXT: {
			const playQueue = Object.assign([], state)
			const previousQueue = playQueue.splice(0, action.currentIndex + 1)
			const nextQueue = playQueue.splice(Math.max(action.currentIndex - 1, 0))

			return [
				...previousQueue,
				...action.playqueue,
				...nextQueue
			]
		}
		case actionsTypes.SET_PLAYQUEUE_END:
			return state.concat(action.playqueue)
		case actionsTypes.CLEAR_PLAYQUEUE:
			return []
		default:
			return state
	}
}

const currentIndex = (state = -1, action) => {
	switch (action.type) {
		case actionsTypes.SET_FROM_STORAGE:
			return action.storage && action.storage.playQueue && action.storage.playQueue.currentIndex !== -1 ?
				action.storage.playQueue.currentIndex :
				-1
		case actionsTypes.SET_MOVE_IN_PLAYQUEUE:
			return action.indexToRead
		case actionsTypes.CLEAR_PLAYQUEUE:
			return  -1
		default:
			return state
	}
}

export default combineReducers({
	queue,
	currentIndex
})



// WEBPACK FOOTER //
// ./src/components/miniPlayer/playqueueReducers.js